module.exports = __webpack_public_path__ + "img/Img9_204466_JcDe-1-5837.dc92652b.jpg";